import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import '../App.css';

const MarketingIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="12" y="30" width="8" height="22" rx="2" stroke="currentColor" strokeWidth="2" />
    <rect x="26" y="22" width="8" height="30" rx="2" stroke="currentColor" strokeWidth="2" />
    <rect x="40" y="14" width="8" height="38" rx="2" stroke="currentColor" strokeWidth="2" />
    <path
      d="M10 18L18 12L30 20L46 6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M45 6H56V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AccountingIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="16" y="8" width="32" height="48" rx="4" stroke="currentColor" strokeWidth="2" />
    <path d="M24 20H40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M24 28H40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M24 36H34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <rect x="24" y="42" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="2" />
    <rect x="34" y="42" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="2" />
    <path
      d="M32 8V4M32 60V56"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PrintingIcon = () => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="18" y="6" width="28" height="18" rx="3" stroke="currentColor" strokeWidth="2" />
    <rect x="16" y="40" width="32" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
    <rect x="8" y="22" width="48" height="26" rx="4" stroke="currentColor" strokeWidth="2" />
    <path d="M22 46H42" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M22 52H42" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="18" cy="30" r="2" fill="currentColor" />
  </svg>
);

const ProcessAutomationIcon = () => (
  <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <circle cx="20" cy="20" r="10" stroke="currentColor" strokeWidth="2" />
    <circle cx="44" cy="20" r="6" stroke="currentColor" strokeWidth="2" />
    <rect x="14" y="38" width="36" height="14" rx="3" stroke="currentColor" strokeWidth="2" />
    <path d="M20 30V38" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M44 26V38" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <circle cx="26" cy="45" r="2" fill="currentColor" />
    <circle cx="38" cy="45" r="2" fill="currentColor" />
  </svg>
);

const DataIntegrationIcon = () => (
  <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect x="12" y="12" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="2" />
    <rect x="34" y="12" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="2" />
    <rect x="12" y="34" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="2" />
    <rect x="34" y="34" width="18" height="18" rx="4" stroke="currentColor" strokeWidth="2" />
    <path d="M30 21H34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M21 30V34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M43 30V34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M30 43H34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const AIIcon = () => (
  <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect x="14" y="14" width="36" height="36" rx="8" stroke="currentColor" strokeWidth="2" />
    <circle cx="24" cy="24" r="4" stroke="currentColor" strokeWidth="2" />
    <circle cx="40" cy="40" r="4" stroke="currentColor" strokeWidth="2" />
    <path d="M24 28V36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M40 24V32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M28 24H32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M32 40H36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 44L24 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M44 20L40 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const AnalyticsIcon = () => (
  <svg width="56" height="56" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <rect x="10" y="10" width="44" height="44" rx="8" stroke="currentColor" strokeWidth="2" />
    <path d="M22 42L28 34L36 38L44 26L50 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="22" cy="42" r="2" fill="currentColor" />
    <circle cx="28" cy="34" r="2" fill="currentColor" />
    <circle cx="36" cy="38" r="2" fill="currentColor" />
    <circle cx="44" cy="26" r="2" fill="currentColor" />
    <circle cx="50" cy="30" r="2" fill="currentColor" />
    <path d="M20 20H44" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

function Home() {
  return (
    <div className="App">
      <Navigation />

      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="hero-title">Automate Your Business,<br />Amplify Your Growth</h1>
          <p className="hero-subtitle">
            We transform manual processes into intelligent automation solutions, 
            helping businesses reduce costs and scale efficiently.
          </p>
          <a href="#schedule" className="cta-button">Schedule a Consultation</a>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <ProcessAutomationIcon />
              </div>
              <h3>Process Automation</h3>
              <p>Streamline repetitive tasks and workflows to increase efficiency and reduce human error.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <DataIntegrationIcon />
              </div>
              <h3>Data Integration</h3>
              <p>Connect your systems and automate data flow between platforms for seamless operations.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <AIIcon />
              </div>
              <h3>AI-Powered Solutions</h3>
              <p>Leverage artificial intelligence to automate complex decision-making processes.</p>
            </div>
            <div className="service-card">
              <div className="service-icon">
                <AnalyticsIcon />
              </div>
              <h3>Analytics & Reporting</h3>
              <p>Automated reporting and analytics to gain insights and make data-driven decisions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Case Studies Preview Section */}
      <section className="case-studies-preview">
        <div className="container">
          <h2 className="section-title">Success Stories</h2>
          <p className="section-subtitle">
            See how we've helped businesses reduce costs and improve efficiency through AI automation
          </p>
          <div className="case-studies-preview-grid">
            <div className="case-study-preview-card">
              <div className="preview-icon">
                <MarketingIcon />
              </div>
              <h3>Marketing Agency</h3>
              <p className="preview-stats">52% Cost Reduction • $1.8M Saved</p>
              <p className="preview-description">
                AI-powered automation helped CreativeFlow Marketing reduce manual work by 70% and increase client capacity by 60%.
              </p>
            </div>
            <div className="case-study-preview-card">
              <div className="preview-icon">
                <AccountingIcon />
              </div>
              <h3>Accounting Firm</h3>
              <p className="preview-stats">48% Cost Reduction • $2.1M Saved</p>
              <p className="preview-description">
                Precision Accounting Group automated data entry and document processing, processing 3x more returns with the same team.
              </p>
            </div>
            <div className="case-study-preview-card">
              <div className="preview-icon">
                <PrintingIcon />
              </div>
              <h3>Printing Company</h3>
              <p className="preview-stats">55% Cost Reduction • $1.5M Saved</p>
              <p className="preview-description">
                MetroPrint Solutions optimized production scheduling and inventory management, reducing order processing time by 75%.
              </p>
            </div>
          </div>
          <div className="case-studies-cta-container">
            <Link to="/case-studies" className="cta-button-secondary">
              View All Case Studies →
            </Link>
          </div>
        </div>
      </section>

      {/* Meeting Scheduling Section */}
      <section id="schedule" className="schedule">
        <div className="container">
          <h2 className="section-title">Schedule a Meeting</h2>
          <p className="section-subtitle">
            Let's discuss how automation can transform your business operations
          </p>
          <div className="schedule-container">
            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/neomat65/30min"
              style={{ minWidth: '320px', height: '700px' }}
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Vulpix Technology</h3>
              <p>Transforming businesses through intelligent automation</p>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <p>hello@vulpixtech.com</p>
              <p>+1 (555) 123-4567</p>
            </div>
            <div className="footer-section">
              <h4>Services</h4>
              <p>Process Automation</p>
              <p>Data Integration</p>
              <p>AI Solutions</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Vulpix Technology. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;

